module.exports = __webpack_public_path__ + "img/template28_mobile.5d98523f.png";